var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-container"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"返回","left-arrow":""},on:{"click-left":_vm.returnHome}}),_c('router-view',{attrs:{"type":_vm.type,"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }